<template>
    <div class="dtu-wrap">
        <div class="dtu-item dtu">
            <div id="dtu-container" style="height: 100%;"></div>						
        </div>
        <div class="dtu-item plc">
            <div id="plc-container" style="height: 100%"></div>
        </div>
    </div>
</template>

<script>
import echarts from 'echarts/lib/echarts';

export default {
    name:"dtu",
    data(){
        return {
            dtu:{ on:150,off:150},
            plc:{on:10,off:10},
        }
    },
    mounted(){
        // 创建DTU
        this.createDTU();
        // 创建PLC
        this.createPLC();
    },
    methods:{
        // 创建DTU
        createDTU(){
            var dom = document.getElementById("dtu-container");
            var myChart = echarts.init(dom);
            var app = {};
            let option = null;
            app.title = '环形图';
            
            option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: 'horizontal',
                    x: 'left',
                    data:['在线','离线'],
                    itemWidth: 8,
                    itemHeight: 8,
                    textStyle:{//图例文字的样式
                        color:'#fff',
                        fontSize:12
                    }
                },
                color:['#37a2da','#ffd85c'],
                series: [
                    {
                        name:'DTU',
                        type:'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '24',
                                    color:'#00fcff',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false,
                            }
                        },
                        data:[
                            {value:this.dtu.on, name:'在线'},
                            {value:this.dtu.off, name:'离线'}
                        ]
                    }
                ]
            };

            if (option && typeof option === "object") {
                myChart.setOption(option, true);
            }
        },
        // 创建PLC
        createPLC(){
            var dom = document.getElementById("plc-container");
            var myChart = echarts.init(dom);
            var app = {};
            let option = null;
            app.title = '环形图';

            option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                color:['#37a2da','#ffd85c'],
                series: [
                    {
                        name:'PLC',
                        type:'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '24',
                                    color:'#00fcff',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data:[
                            {value:this.plc.on, name:'在线'},
                            {value:this.plc.off, name:'离线'}
                        ]
                    }
                ]
            };
            if (option && typeof option === "object") {
                myChart.setOption(option, true);
            }
        }
    }
}
</script>

<style lang="scss">
.dtu-wrap{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;

    .dtu-item{
        flex: 1;
    }
}
</style>